/**
 * This Regular Expression will check if the url
 * is a valid image url by checking the extension
 * on jpg, jpeg, png, webp, avif, gif or svg.
 *
 * (\?.+|\?|$)  Checks if the following character is a '?'
 * or if it is the end of the string '$'.
 *
 * @param {string} url - The url of the image
 * @returns {boolean}
 */
export const isValidImageUrl = (url) => /^https?:\/\/.+\.(jpg|jpeg|png|webp|avif|gif|svg)(\?.+|\?|$)$/.test(url);
//# sourceMappingURL=isValidImageUrl.js.map